"use client";

// app/blog/_components/NewsletterForm.tsx
// Wire submit() to your ESP (ConvertKit, Mailchimp, etc.) via your API route.

import { useState } from "react";

export function NewsletterForm({ withBullets = false }: { withBullets?: boolean }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "loading" | "ok" | "error">("idle");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      // YOUR API HOOK:
      // await fetch("/api/newsletter", { method: "POST", body: JSON.stringify({ email }) });
      await new Promise((r) => setTimeout(r, 600)); // demo only
      setState("ok");
    } catch {
      setState("error");
    }
  }

  return (
    <section className="lx-newsletter" aria-label="Newsletter signup">
      <div>
        <div className="lx-newsletter-eyebrow">Translation Insights newsletter</div>
        <h2>Get translation, localization & global business insights — once a week.</h2>
        <p>Practical guides, language-pair benchmarks, and product news from Languex.</p>
        {withBullets && (
          <ul className="lx-newsletter-bullets">
            <li>
              <CheckSm /> Industry data nobody else publishes
            </li>
            <li>
              <CheckSm /> Language-pair pricing & turnaround benchmarks
            </li>
            <li>
              <CheckSm /> Product news first — before anyone else
            </li>
          </ul>
        )}
      </div>
      <div>
        <form className="lx-newsletter-form" onSubmit={submit}>
          <input
            type="email"
            required
            placeholder="you@company.com"
            aria-label="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={state === "loading" || state === "ok"}
          />
          <button type="submit" disabled={state === "loading"}>
            {state === "ok" ? "Subscribed ✓" : state === "loading" ? "Subscribing..." : "Subscribe"}
          </button>
        </form>
        <p className="lx-newsletter-foot">
          Join 12,000+ B2B translation buyers. Read by teams at Stripe, Notion, and Shopify.
        </p>
      </div>
    </section>
  );
}

function CheckSm() {
  return (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
